/**
 * tapLanding.ts
 *
 * The bits of the public /tap/:deskToken landing page that need no React:
 * store links and the optional deep link into the patient app.
 *
 * The page is the fallback for a phone that read the front-desk pad but did
 * not hand the link to the Next Health app (app not installed, or the app has
 * not yet shipped Universal Links). It is deliberately static: it never calls
 * the API and never shows the desk token as text — the token only ever appears
 * inside a deep-link href, URL-encoded.
 *
 * APP_SCHEME stays empty until the app team confirms the custom URL scheme the
 * app registers (for example "nexthealth"). While it is empty the page shows
 * store links only; a same-domain Universal Link tapped from Safari does not
 * reopen the app, so a custom scheme is the only way to offer "Open the app"
 * from here.
 */

export const APP_SCHEME = '';

export const STORE_LINKS = {
  ios: 'https://apps.apple.com/us/app/next-health/id1412279340',
  android: 'https://play.google.com/store/apps/details?id=app.nexthealth',
} as const;

/** Deep link into the app for this desk, or null when no scheme is configured. */
export function openAppHref(scheme: string, deskToken: string): string | null {
  const s = scheme.trim().replace(/:\/\/$/, '').replace(/:$/, '');
  const token = deskToken.trim();
  if (!s || !token) return null;
  return `${s}://tap/${encodeURIComponent(token)}`;
}
